<form [formGroup]="assetStorageUploadEditorForm">
  @if(assetStorageUploadEditorForm.controls.id.value === null){
    <div class="row form-group">
      <div class="col-12">
        <label class="control-label">{{'i18n.domain.assets.asset-storage.edit-asset-storage.use-static-file-name' | translate}}</label>
        <app-yes-no-group-button formControlName="isStaticFileName">
        </app-yes-no-group-button>
      </div>
    </div>
  }
  <div class="row form-group">
    <div class="col-12">
      <label class="control-label required">{{'i18n.domain.assets.asset-storage.edit-asset-storage.license' | translate}}</label>
      <ejs-dropdownlist [dataSource]="licenses" id="license" formControlName="license" [fields]="fields">
        <ng-template #itemTemplate let-data>
          {{data.text | translate}}
        </ng-template>
        <ng-template #valueTemplate let-data>
          <div class="centered">
            <span>{{data.text | translate}}</span>
          </div>
        </ng-template>
      </ejs-dropdownlist>
      <app-error-messages [control]="assetStorageUploadEditorForm.controls.license"></app-error-messages>
    </div>
  </div>
  <div class="row form-group">
    <div class="col-12">
      <label for="source" class="control-label">{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.source' | translate }}</label>
      <input id="source" type="text" class="form-control" formControlName="source" />
      <app-error-messages [control]="assetStorageUploadEditorForm.controls.source"></app-error-messages>
    </div>
  </div>
  <div class="row form-group">
    <div class="col-12">
      <label class="control-label required">{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.language' | translate }}</label>
      <ejs-dropdownlist [dataSource]="languages" id="language" formControlName="language">
      </ejs-dropdownlist>
      <app-error-messages [control]="assetStorageUploadEditorForm.controls.language"></app-error-messages>
    </div>
  </div>
  @if(isImage){
    <div class="row form-group">
      <div class="col-12">
        <label class="control-label">{{'i18n.domain.assets.asset-storage.edit-asset-storage.image-quality' | translate}}</label>
        <ejs-dropdownlist [dataSource]="imageQualities" id="imageQuality" formControlName="imageQuality" [fields]="fields">
          <ng-template #itemTemplate let-data>
            {{data.text | translate}}
          </ng-template>
          <ng-template #valueTemplate let-data>
            <div class="centered">
              <span>{{data.text | translate}}</span>
            </div>
          </ng-template>
        </ejs-dropdownlist>
        <app-error-messages [control]="assetStorageUploadEditorForm.controls.imageQuality"></app-error-messages>
      </div>
    </div>
  }
  @if(assetStorageUploadEditorForm.controls.id.value || assetStorageUploadEditorForm.controls.isStaticFileName.value){
    <div class="row form-group">
      @if(assetStorageUploadEditorForm.controls.id.value){
        <div class="col-12">
          <label class="control-label">{{'i18n.domain.assets.asset-storage.edit-asset-storage.file-name' | translate}}</label>
          <div class="value-text">{{this.assetStorageUploadEditorForm.controls.originalFileName.value}}</div>
        </div>
      }
      @if(!assetStorageUploadEditorForm.controls.id.value && assetStorageUploadEditorForm.controls.isStaticFileName.value){
        <div class="col-12">
          <label for="originalFileName" class="control-label required">{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.file-name' | translate }}</label>
          <input id="originalFileName" type="text" class="form-control" formControlName="originalFileName" />
          <app-error-messages [control]="assetStorageUploadEditorForm.controls.originalFileName"></app-error-messages>
        </div>
      }
    </div>
  }
  @if(assetStorageUploadEditorForm.controls.id.value !== null){
    <div class="row form-group">
      <div class="col-12">
        <label class="control-label">{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.is-static-file-name' | translate }}</label>
        <div class="value-text">{{this.assetStorageUploadEditorForm.controls.isStaticFileName.value ? ('i18n.shared.yes' | translate) : ('i18n.shared.no' | translate)}}</div>
      </div>
    </div>
  }
  <div class="row">
    <label class="control-label">{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.key-words.title' | translate}}</label>
    <div class="col-11">
      <app-multi-select-filter #multiselectFilter
                              [getDataFunction]="searchAssetStorageKeyWords.bind(this)"
                              [(values)]="selectedKeyWordId"
                              [type]="MultiSelectFilterType.MultiSelectItem"
                              placeholder=""
                              id="name">
      </app-multi-select-filter>
      <app-error-messages [control]="assetStorageUploadEditorForm.controls.assignedAssetKeyWords"></app-error-messages>
    </div>
    <div class="col-1 d-flex">
      <span class="e-icons icon-add e-icon-big d-flex align-items-center"
            (click)="onAddKeyWord()"
            title="{{ 'i18n.domain.assets.asset-storage.edit-asset-storage.key-words.add' | translate }}">
      </span>
    </div>
  </div>
</form>

<app-asset-storage-add-key-word-dialog #addKeyWordDialog (keyWordAdded)="onKeyWordAdded($event)"></app-asset-storage-add-key-word-dialog>
